export default {
  name: 'KpiPeriodList',
  data () {
    return {
      openedItem: null,
      tableItems: null,
      years: null,
      isMounted: false,
      isLoading: false,
      isEditUpdating: false,
      paging: {
        page: 1,
        pages: 1,
        limit: 20,
        total: 0
      },
      tableSorting: { item: 'title', direction: 'asc' },
      filterValues: {
        title: null
      }
    }
  },
  computed: {
    canEdit () {
      return true;
    },
    periodTypesOptions () {
      const types = this.$store.getters.getConfigOptions('period_types');
      types.forEach(type => {
        type.text = this.$t('general.period_types.' + type.value);
        type.code = type.value;
      });
      return types;
    },
    requestPath () {
      const path = 'kpi/periods/?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      return this.ApiRequest.addGetParamsToPath(
        path,
        (this.$refs.tableview ? this.$refs.tableview.getFilterValues() : this.filterValues),
        true
      );
    },
    tableHeaders () {
      const headers = [
        { key: 'type', label: this.$t('kpi.periods.type'), class: 'col-width-xl', filterKey: 'type', format: 'formatFunc', funcs: [this.getTypeName] },
        { key: 'name.' + this.$i18n.locale, label: this.$t('kpi.periods.name'), class: 'col-width-xl' },
        { key: 'start', label: this.$t('kpi.periods.start'), class: 'col-width-xl', type: 'date' },
        { key: 'end', label: this.$t('kpi.periods.end'), class: 'col-width-xl', type: 'date' },
        { key: 'kpi_last_edit_date', label: this.$t('kpi.periods.kpi_last_edit_date'), class: 'col-width-xl', type: 'date' },
        { key: 'kpi_last_evaluation_date', label: this.$t('kpi.periods.kpi_last_evaluation_date'), class: 'col-width-xl', type: 'date' }
      ];

      const actions = [];
      if (this.canEdit) {
        actions.push({ label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-warning btn-sm' });
      }
      headers.push({ key: 'actions', label: '', actions: actions, headerClass: 'col-1' });

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      if (this.canEdit && this.isBaseDataFilled) {
        actions.add = { title: this.$t('general.actions.create-new') };
      }
      return actions;
    },
    tableFilterConfig () {
      const filters = {};
      filters.type = {
        type: 'checkbox',
        label: this.$t(''),
        colOnlyFilter: true,
        options: this.periodTypesOptions,
        class: 'col-md-8'
      }
      return filters;
    }
  },
  methods: {
    save () {
      this.isEditUpdating = true;
      this.ApiRequest.request('kpi/periods/' + this.openedItem.id, this.ApiRequest.REQUEST_PATCH, this.openedItem, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.$store.commit('toastAdd', { context: 'success', message: this.$t('kpi.periods.updated-successfully') });
          const item = this.tableItems[parseInt(this.openedItem.itemIndex)];
          if (item) {
            item.kpi_last_edit_date = this.openedItem.kpi_last_edit_date;
            item.kpi_last_evaluation_date = this.openedItem.kpi_last_evaluation_date;
          }
        }
        this.isEditUpdating = false;
        this.openedItem = null;
        this.$refs.editKpiPeriod.hide();
      });
    },
    cancel () {
      this.openedItem = null;
      this.$refs.editKpiPeriod.hide();
    },
    editItem (data) {
      this.openedItem = data;
      this.$refs.editKpiPeriod.show(data);
    },
    getTypeName (type) {
      return this.$t('general.period_types.' + type);
    },
    updateFilters () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    getTableData () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data.periods;
          this.years = response.data.years;
          this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    }
  },
  mounted () {
    this.getTableData();
    this.isMounted = true;
  }
}
